import { combineReducers } from "redux";
import articulos from "./articulos";
import articulo from "./articulo";
import pedidos from "./pedidos";
import informes from "./informes";
import messages from "./messages";
import auth from "./auth";
import loader from "./loader";
import portal from "./portal";
import precios from "./precios";
import stocks from "./stocks";
import listasCompra from "./listasCompra";
import descripcion from "./descripcion";
import modalGenerica from "./modalGenerica";
import pedidosAnteriores from "./pedidosAnteriores";
import pedidosPendientes from "./pedidosPendientes";
import contacto from "./contacto";
import listadoArticulos from "./listadoArticulos";
import avisos from "./avisos";
import formasEnvio from "./formasEnvio";
import domiciliosEnvio from "./domiciliosEnvio";
import almacenes from "./almacenes";
import rutas from "./rutas";
import galeria from "./galeria";
import widgets from "./widgets";
import informesFiltroLov from "./informesFiltroLov";
import provincias from "./provincias";
import estados from "./estados";
import expedientes from "./expedientes";
import banners from "./banners";
import tiposNif from "./tiposNif";
import imagen from "./imagen";
import migas from "./migas";
import agrupaciones from "./agrupaciones";
import tiras from "./tiras";
import formasPago from "./formasPago";
import modular from "./modular";
import tiposPedido from "./tiposPedido";
import comunidadesAutonomas from "./comunidadesAutonomas";
import subpresentaciones from "./subpresentaciones";
import textosVentas from "./textosVentas";
import presentaciones from "./presentaciones";
import ofertasMultiples from "./ofertasMultiples";
import familias from "./familias";
import usuarioshijos from "./usuariosHijos";
import efacturaCompras from "./efacturaCompras";
import efacturaVentas from "./efacturaVentas";
import organizacionesCompras from "./organizacionesCompras";
import transportistas from "./transportistas";
import festivos from "./festivos";
import tarifas from "./tarifasEnvioPortes";
import languageSelector from "./languageSelector";
import plantillas from "./plantillas";
import articulosKit from "./articulosKit";
import articulosConjunto from "./articulosConjunto";
import selectorCliente from "./selectorCliente";

export default combineReducers({
  articulos,
  articulo,
  pedidos,
  informes,
  messages,
  auth,
  loader,
  portal,
  precios,
  stocks,
  listasCompra,
  descripcion,
  modalGenerica,
  pedidosAnteriores,
  pedidosPendientes,
  contacto,
  listadoArticulos,
  avisos,
  formasEnvio,
  domiciliosEnvio,
  almacenes,
  rutas,
  galeria,
  widgets,
  informesFiltroLov,
  provincias,
  estados,
  expedientes,
  tiposNif,
  banners,
  imagen,
  migas,
  agrupaciones,
  tiras,
  formasPago,
  modular,
  tiposPedido,
  comunidadesAutonomas,
  subpresentaciones,
  familias,
  textosVentas,
  presentaciones,
  usuarioshijos,
  efacturaCompras,
  efacturaVentas,
  organizacionesCompras,
  ofertasMultiples,
  transportistas,
  festivos,
  tarifas,
  languageSelector,
  plantillas,
  articulosKit,
  articulosConjunto,
  selectorCliente,
});
